<template>
  <div style="position: relative">
    <div
      ref="chartContainer"
      :id="chartId"
      :chartName="chartName"
      :chartType="chartType"
      :chartData="chartData"
      :style="styleGroup"
      :changePage="changePage"
    >
      <!-- {{ chartId }} -->
    </div>
    <button
      v-if="exportChart"
      class="btn btn-outline-secondary btn-export"
      @click="submitExport(chartId)"
    >
      匯出圖表
    </button>
  </div>
</template>

<script>
import { inject, onMounted, onUnmounted, ref, watch } from "vue";
import * as echarts from "echarts";
export default {
  props: {
    chartId: String,
    chartName: String,
    chartType: String,
    chartData: Object,
    styleGroup: {
      type: Object,
      default: { width: "100%", height: "250px" },
    },
    changePage: Number,
    reDraw: {
      type: Boolean,
      default: false,
    },
    exportChart: { type: Boolean, default: false },
    exportChartName: { type: String, default: "chart" },
  },
  setup(props) {
    const chartContainer = ref(null);
    const chartsUrl = inject("chartsUrl", null);
    const drawChart = () => {
      let type = props.chartType;
      if (
        !chartContainer.value ||
        chartContainer.value.clientWidth === 0 ||
        chartContainer.value.clientHeight === 0
      ) {
        setTimeout(() => {
          drawChart();
        }, 100);
        return;
      }
      switch (type) {
        case "customize":
          // 可參考 https://echarts.apache.org/examples/zh/index.html
          // 將option填入
          customizeChart(props);
          break;
        case "line":
          lineChart(props);
          break;
        case "VerticalBarLine":
          VerticalBarLineChart(props);
          break;

        default:
          break;
      }
      if (chartsUrl != null) getUrl();
    };

    const customizeChart = () => {
      // console.log("this chart type is : customize");
      // console.log(props.chartData);
      let echarts = require("echarts");
      //判斷是否已經實例化
      let myChart = echarts.getInstanceByDom(
        document.getElementById(props.chartId)
      );
      // console.log(myChart);
      if (myChart == null) {
        //預設值
        let chartOption = {
          title: {
            text: props.chartName,
            left: "center",
          },
        };
        let optionKeys = Object.keys(props.chartData);
        optionKeys.forEach((data) => {
          chartOption[data] = props.chartData[data];
        });
        myChart = echarts.init(document.getElementById(props.chartId));
        myChart.setOption(chartOption);
        window.addEventListener("resize", function () {
          myChart.resize(); //初始化的
        });
      } else {
        //僅更新數值，若有錯誤則重新執行一次
        try {
          let chartOption = myChart.getOption();

          //如果對應資料的名稱不一樣則重繪
          if (
            JSON.stringify(chartOption.series.map((item) => item.name)) !=
              JSON.stringify(props.chartData.series.map((item) => item.name)) ||
            props.reDraw == true
          ) {
            myChart.dispose(); //釋放/刪除圖表資源
            drawChart();
            return;
          }

          chartOption.series = props.chartData.series;
          myChart.setOption(chartOption);
        } catch (e) {
          myChart.dispose(); //釋放/刪除圖表資源
          drawChart();
        }
      }
    };

    const lineChart = () => {
      // chartData範例
      // props.chartData = {
      //   series: [
      //     { name: "打頭", data: [5, 5, 9, 10, 6, 8], smooth: true },
      //     { name: "輾牙", data: [5, 5, 9, 10, 6, 8], smooth: true },
      //   ],
      //   xAxis: ["1月", "2月", "3月", "4月", "5月", "6月"],
      // };

      //折線圖

      let echarts = require("echarts");
      //判斷是否已經實例化
      let myChart = echarts.getInstanceByDom(
        document.getElementById(props.chartId)
      );
      if (myChart == null) {
        let dataName = [];
        let optionSeries = [];
        if (
          props.chartData.series != undefined &&
          Array.isArray(props.chartData.series)
        ) {
          props.chartData.series.forEach((data) => {
            let thisDataObj = {
              name: "",
              type: "line",
              data: [],
              smooth: false,
            };
            if (data.name != undefined) {
              dataName.push(data.name);
              thisDataObj.name = data.name;
            }
            if (data.smooth != undefined) {
              thisDataObj.smooth = data.smooth;
            }
            if (data.data != undefined) {
              thisDataObj.data = data.data;
              optionSeries.push(thisDataObj);
            }
          });
        }

        let chartOption = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          legend: {
            x: "right",
            y: "center",
            orient: "vertical",
            data: dataName,
            padding: [0, 35, 0, 0],
          },
          xAxis: {
            type: "category",
            splitLine: {
              show: false,
            },
            data: props.chartData.xAxis,
          },
          yAxis: { type: "value" },
          series: optionSeries,
        };

        myChart = echarts.init(document.getElementById(props.chartId));
        myChart.setOption(chartOption);
        window.addEventListener("resize", function () {
          myChart.resize(); //初始化的
        });
      } else {
        //僅更新數值，若有錯誤則重新執行一次
        try {
          let chartOption = myChart.getOption();
          chartOption = Object.assign({}, chartOption);

          //如果對應資料的名稱不一樣則重繪
          if (
            JSON.stringify(chartOption.series.map((item) => item.name)) !=
            JSON.stringify(props.chartData.series.map((item) => item.name))
          ) {
            myChart.dispose(); //釋放/刪除圖表資源
            drawChart();
            return;
          }

          chartOption.series = props.chartData.series;
          chartOption.xAxis[0].data = props.chartData.xAxis;
          myChart.setOption(chartOption);
        } catch (e) {
          myChart.dispose(); //釋放/刪除圖表資源
          drawChart();
        }
      }
    };

    const VerticalBarLineChart = () => {
      // chartData範例
      // props.chartData = {
      //   series: [
      //     { name: "打頭", data: [91, 96, 61, 26, 0, 44], smooth: true },
      //     { name: "輾牙", data: [5, 5, 9, 10, 6, 8], smooth: true },
      //   ],
      //   xAxis: ["2023-03-01", "2023-03-02", "2023-03-03", "2023-03-04", "2023-03-05", "2023-03-06"],
      //   lineName: "平均",
      //   unit: "%"
      // };

      console.log("this chart type is : VerticalBarLine");
      // 折線長條圖

      let echarts = require("echarts");
      //判斷是否已經實例化
      let myChart = echarts.getInstanceByDom(
        document.getElementById(props.chartId)
      );
      let lineData = {
        name:
          props.chartData.lineName != undefined
            ? props.chartData.lineName
            : "平均",
        type: "line",
        data: [],
        smooth: false,
      };
      let lineArray = [];
      if (myChart == null) {
        let dataName = [];
        let optionSeries = [];
        console.log(props.chartData.series);
        if (
          props.chartData.series != undefined &&
          Array.isArray(props.chartData.series)
        ) {
          props.chartData.series.forEach((data) => {
            let thisDataObj = {
              name: "",
              type: "bar",
              data: [],
              smooth: false,
            };
            if (data.name != undefined) {
              dataName.push(data.name);
              thisDataObj.name = data.name;
            }
            if (data.smooth != undefined) {
              thisDataObj.smooth = data.smooth;
            }
            if (data.data != undefined) {
              thisDataObj.data = data.data;
              optionSeries.push(thisDataObj);
              data.data.forEach((value, index) => {
                if (lineArray[index] == undefined) {
                  lineArray[index] = 0;
                }
                lineArray[index] += value;
              });
            }
            console.log(optionSeries);
          });
        }

        let optionSeriesLength = optionSeries.length;
        lineArray.forEach((data, index) => {
          lineArray[index] = Math.round((data / optionSeriesLength) * 10) / 10;
        });
        lineData.data = lineArray;
        optionSeries.push(lineData);

        let unit = "";
        if (props.chartData.unit != undefined) {
          unit = props.chartData.unit;
        }

        let chartOption = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          legend: {
            bottom: 0,
            data: dataName,
          },
          grid: {
            top: "20%",
            left: "4%",
            right: "4%",
            bottom: "12%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              data: props.chartData.xAxis,
              axisPointer: {
                type: "shadow",
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: unit != "" ? "單位 " + unit : "",
              minInterval: 1,
              // max: 100,
            },
          ],

          series: optionSeries,
        };

        myChart = echarts.init(document.getElementById(props.chartId));
        myChart.setOption(chartOption);
        window.addEventListener("resize", function () {
          setTimeout(() => {
            myChart.resize(); //初始化的
          }, 3000);
        });
      } else {
        //僅更新數值，若有錯誤則重新執行一次
        try {
          let chartOption = myChart.getOption();
          chartOption = Object.assign({}, chartOption);

          //資料長度不一樣就重繪(-1是因為多了一個平均)
          if (chartOption.series.length - 1 != props.chartData.series.length) {
            myChart.dispose(); //釋放/刪除圖表資源
            drawChart();
            return;
          }
          chartOption.series = props.chartData.series;

          chartOption.series.forEach((data) => {
            if (data.data != undefined) {
              data.data.forEach((value, index) => {
                if (lineArray[index] == undefined) {
                  lineArray[index] = 0;
                }
                lineArray[index] += value;
              });
            }
          });
          let chartOptionSeriesLength = chartOption.series.length;
          lineArray.forEach((data, index) => {
            lineArray[index] =
              Math.round((data / chartOptionSeriesLength) * 10) / 10;
          });
          lineData.data = lineArray;
          console.log(lineData);
          chartOption.series.push(lineData);

          //如果對應資料的名稱不一樣則重繪
          if (
            JSON.stringify(chartOption.series.map((item) => item.name)) !=
            JSON.stringify(props.chartData.series.map((item) => item.name))
          ) {
            myChart.dispose(); //釋放/刪除圖表資源
            drawChart();
            return;
          }

          chartOption.xAxis[0].data = props.chartData.xAxis;
          myChart.setOption(chartOption);
        } catch (e) {
          console.log(e);
          myChart.dispose(); //釋放/刪除圖表資源
          drawChart();
        }
      }
    };

    const submitExport = (chartId) => {
      let myChart = echarts.getInstanceByDom(document.getElementById(chartId));
      if (myChart == null) return;
      let base64Data = myChart.getDataURL({
        pixelRatio: 2,
        backgroundColor: "#fff",
      });
      const link = document.createElement("a");
      link.href = base64Data;
      link.download = `${props.exportChartName}.png`;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    const getUrl = () => {
      let myChart = echarts.getInstanceByDom(
        document.getElementById(props.chartId)
      );
      if (myChart == null) return;
      let base64Data = myChart.getDataURL({
        pixelRatio: 2,
        backgroundColor: "#fff",
      });
      setTimeout(() => {
        chartsUrl.value[props.chartId] = base64Data;
      }, 500);
    };

    onMounted(() => {
      drawChart();
    });

    onUnmounted(() => {
      echarts.dispose;
    });

    watch(
      () => props.chartId,
      () => {
        drawChart();
      },
      { deep: true }
    );
    watch(
      () => props.chartData,
      () => {
        drawChart();
      },
      { deep: true }
    );

    return {
      chartContainer,
      submitExport,
    };
  },
};
</script>

<style scoped>
.btn-export {
  position: absolute;
  top: 0px;
  right: 30px;
  height: 20px;
  padding: 0px 0.5rem;
  font-size: 14px;
}
</style>
